<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="8" sm="10">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.auctionsHistory') }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <auctions-list @itemSelected="itemSelected"></auctions-list>
      </v-col>
    </v-row>

    <v-dialog v-model="isAuctionDetailDialogOpen" max-width="1000" persistent>
      <auction-detail :auctionId="auctionSelected.id" :isActive="isAuctionDetailDialogOpen" @close="closeDetailDialog"></auction-detail>
    </v-dialog>

   <v-dialog v-model="isAuctionEvaluationDialogOpen" max-width="700" persistent>
      <auction-evaluation :auctionId="auctionSelected.id" :isActive="isAuctionEvaluationDialogOpen" @close="closeEvaluationDialog"></auction-evaluation>
    </v-dialog>

   <v-dialog v-model="isAuctionChatDialogOpen" max-width="1000" persistent>
      <auction-chat :auctionId="auctionSelected.id" :isActive="isAuctionChatDialogOpen" @close="closeChatDialog"></auction-chat>
    </v-dialog>
  </v-container>
</template>

<script>
import { loading, showMessage } from '../../mixins'
import AuctionChat from '../../components/Auctions/auctions/AuctionChat'
import AuctionDetail from '../../components/Auctions/auctions/AuctionDetail'
import AuctionEvaluation from '../../components/Auctions/auctions/AuctionEvaluation'
import AuctionsList from '../../components/Auctions/auctions/AuctionsList'

export default {
  name: 'AuctionsHistory',
  components: { AuctionsList, AuctionDetail, AuctionEvaluation, AuctionChat },
  mixins: [loading, showMessage],
  data: () => ({
    isAuctionDetailDialogOpen: false,
    isAuctionEvaluationDialogOpen: false,
    isAuctionChatDialogOpen: false,
    auctionSelected: {}
  }),
  methods: {
    itemSelected (item, action) {
      this.auctionSelected = Object.assign({}, item)
      switch (action) {
        case 'detail':
          this.isAuctionDetailDialogOpen = true
          break
        case 'evaluation': {
          this.isAuctionEvaluationDialogOpen = true
          break
        }
        case 'chat': {
          this.isAuctionChatDialogOpen = true
          break
        }
      }
    },
    closeDetailDialog () {
      this.isAuctionDetailDialogOpen = false
      this.auctionSelected = {}
    },
    closeEvaluationDialog () {
      this.isAuctionEvaluationDialogOpen = false
      this.auctionSelected = {}
    },
    closeChatDialog () {
      this.isAuctionChatDialogOpen = false
      this.auctionSelected = {}
    }
  }
}
</script>

<style>

</style>
